<template>
  <div class="ticket-on-hold-container">
    <div
      :class="{ 'right-class': $i18n.locale === 'ar' }"
      class="ticket-on-hold-title d-flex align-items-center gap-2"
    >
      <button
        type="button"
        class="large-button"
        @click="showOnHoldTicketsDrawer = true"
      >
        <img
          class="small-button-image"
          src="../assets/icons/hourglass_grey.png"
          alt="Ticket on hold"
        />
      </button>
      {{ $t("Teller.Waiting_Tickets") }}
    </div>
    <div
      v-if="teller_config?.business?.myLiberrex?.queue_on_hold !== 1"
      class="no-data-container justify-content-around"
      :class="{ 'right-class': $i18n.locale === 'ar' }"
    >
      <div class="statistics-image-container">
        <img src="../assets/images/no-ticket-data.png" />
      </div>
      <div class="no-data-label">{{ $t("Teller.no_service") }}</div>
    </div>
    <div
      v-else-if="waiting_list.length !== 0"
      class="tickets-on-hold-wrap"
      :class="{ 'right-class': $i18n.locale === 'ar' }"
    >
      <div class="tickets-strip">
        <div
          class="ticket-grid-cell"
          :id="'onHold-' + item.public_identifier"
          v-for="item in waiting_list.slice(0, 3)"
          :key="item.ticket_id || item.public_identifier"
        >
          <div class="ticket-on-hold justify-content-between">
            <span
              class="ticket-value"
              :style="
                'font-size:' +
                fixFontSize(String(item.public_identifier).replace(' ', '')) +
                ' !important; line-height: ' +
                fixLineHeight(String(item.public_identifier).replace(' ', '')) +
                ' !important; '
              "
              >{{ String(item.public_identifier).replace(" ", "") }}</span
            >
            <div class="ticket-buttons">
              <img
                class="ticket-button"
                src="../assets/icons/clear-button-icon.svg"
                alt="Delete Ticket"
                @click="endTicket(item.public_identifier)"
              />
              <img
                class="ticket-button"
                src="../assets/icons/eject-button-icon.svg"
                alt="Recall Ticket"
                @click="recallHoldTicket(item.ticket_id)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="no-data-container justify-content-around"
      v-else
      :class="{ 'right-class': $i18n.locale === 'ar' }"
    >
      <div class="statistics-image-container">
        <img src="../assets/images/no-ticket-data.png" />
      </div>
      <div class="no-data-label">{{ $t("Teller.No_ticket") }}</div>
    </div>
  </div>

  <lbrx-on-hold-tickets-drawer
    v-model="showOnHoldTicketsDrawer"
    :waiting_list="waiting_list"
    @close="showOnHoldTicketsDrawer = false"
    @endTicket="endTicket($event)"
    @returnOnHoldTicket="recallHoldTicket($event)"
  ></lbrx-on-hold-tickets-drawer>
</template>
<script>
import LbrxOnHoldTicketsDrawer from "./LbrxOnHoldTicketsDrawer.vue";
export default {
  components: {
    LbrxOnHoldTicketsDrawer,
  },
  name: "LbrxTicketOnHold",
  props: {
    waiting_list: Array,
    modelValue: Object,
  },
  data() {
    return {
      teller_config: (this.teller_config = JSON.parse(
        localStorage.getItem("user") || "{}"
      )),
      showOnHoldTicketsDrawer: false,
    };
  },
  methods: {
    recallHoldTicket(id) {
      this.$emit("returnOnHoldTicket", id);
    },
    endTicket(public_identifier) {
      this.$emit("endTicket", public_identifier);
    },
    fixFontSize(public_identifier) {
      if (public_identifier.length > 3) {
        return "2.5vmin";
      }
      return "3.7vmin";
    },
    fixLineHeight(public_identifier) {
      if (public_identifier.length > 3) {
        return "2.9vmin";
      }
      return "5.4vmin";
    },
  },
};
</script>

<style scoped>
.large-button {
  background: none;
  border: 2px solid #8a8a8a;
  cursor: pointer;
  padding: 0.5vmin;
  border-radius: 5px;
  font-size: 1vmin;
  color: #8a8a8a;
  font-weight: 600;
  font-family: "Exo 2", serif;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 100%;
  text-align: center;
  transition: all 0.3s ease;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.large-button:hover {
  border-color: #6a6a6a;
  color: #6a6a6a;
}

.large-button:focus-visible {
  outline: 2px solid #028fca;
  outline-offset: 2px;
}

@media (max-width: 767px) {
  .small-button-image {
    height: 3vmin !important;
  }
}
.small-button-image {
  height: 2.3vmin !important;
}
.ticket-value {
  width: 100%;

  font-family: "Digital Numbers", serif !important;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;

  color: #ffffff;
}

.ticket-button {
  cursor: pointer;
  height: 3vmin;
  min-height: 22px;
  margin-top: -0.3vmin;
  margin-bottom: 1vmin;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.ticket-button:hover {
  opacity: 0.85;
}

.ticket-button:active {
  transform: scale(0.96);
}

.ticket-buttons {
  height: 100%;
  padding: 0.1vmin;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.tickets-on-hold-wrap {
  width: 100%;
  min-width: 0;
  margin-top: 15px;
  box-sizing: border-box;
}

.tickets-on-hold-wrap.right-class {
  margin-left: 0;
  margin-right: 15px;
  padding-right: 0;
  padding-left: 15px;
}

.tickets-on-hold-wrap.right-class .tickets-strip {
  direction: rtl;
}

/* Single row + horizontal scroll when the panel is narrow */
.tickets-strip {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  margin-bottom: 2px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.22) transparent;
}

.tickets-strip::-webkit-scrollbar {
  height: 5px;
}

.tickets-strip::-webkit-scrollbar-track {
  background: transparent;
}

.tickets-strip::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 4px;
}

.tickets-strip::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.28);
}

.ticket-grid-cell {
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
}

.ticket-on-hold {
  box-sizing: border-box;
  padding: 1vmin;
  width: 16vmin;
  min-width: 7.5rem;
  max-width: 11.5rem;
  height: 9vmin;
  min-height: 52px;
  background: #ffce00;
  display: flex;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12); */
}

.ticket-on-hold-container {
  width: 100% !important;
  min-width: 0;
  height: 100% !important;
  min-height: 21vh !important;
  padding: 20px;
  background: white;
}

.ticket-on-hold-title {
  font-family: "Exo 2", serif;
  font-style: normal;
  margin-bottom: 1vmin;
  min-width: 40vmin !important;

  font-weight: 400 !important;
  font-size: 2.4vmin;
  line-height: 2vmin;

  /* Medium Gray */

  color: #8a8a8a;
}

.ticket-on-hold-title.right-class {
  direction: rtl;
}

.no-data-container {
  width: 100%;
  height: 10vmin;
  min-height: 10vmin;
  margin-top: 2vmin;
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-data-container.right-class {
  direction: rtl;
}

.statistics-image-container img {
  height: 9vmin;
}

.statistics-image-container {
  width: 50%;
  display: flex;
  justify-content: center;
}

.no-data-label {
  width: 100%;
  /*  text-align: left !important;*/
  margin-top: 1.6vmin;
  font-family: "Exo 2", serif;
  font-style: normal;
  font-weight: 400;
  font-size: 3.2vmin;
  line-height: 4vmin;

  /* Gray Light */

  color: #e3e3e3;
}

@media (max-width: 767px) {
  .tickets-on-hold-wrap {
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .tickets-on-hold-wrap.right-class {
    padding-left: 0;
    padding-right: 0;
  }

  .tickets-strip {
    gap: 10px;
  }

  .no-data-container {
    flex-wrap: wrap;
    height: auto;
    min-height: 10vmin;
    padding: 8px 0;
  }

  .statistics-image-container {
    width: 100%;
  }

  .no-data-label {
    text-align: center;
    margin-top: 0.8vmin;
  }
}
</style>